export const menuProps = {
  slotProps: {
    paper: {
      sx: {
        mt: 0.5,
        maxHeight: 280,
        borderRadius: '4px',
        boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.16)',

        '& .MuiMenu-list': {
          p: 0
        },

        '& .MuiMenuItem-root': {
          minHeight: 32,
          px: 2,
          fontSize: 13,
          fontWeight: 400,
          color: '#424242',

          '&:hover': {
            backgroundColor: '#FCF8F2'
          },

          '&.Mui-selected': {
            backgroundColor: '#FFFFFF'
          },

          '&.Mui-selected:hover': {
            backgroundColor: '#FCF8F2'
          },

          '&.Mui-focusVisible': {
            backgroundColor: '#FCF8F2'
          }
        }
      }
    }
  }
};

export const textFieldSx = {
  '& .MuiOutlinedInput-root': {
    height: 42,
    borderRadius: '4px',
    backgroundColor: '#FFFFFF',

    '& fieldset': {
      borderColor: '#D9D9D9'
    },

    '&:hover fieldset': {
      borderColor: '#C4C4C4'
    },

    '&.Mui-focused fieldset': {
      borderColor: '#1976D2',
      borderWidth: '1px'
    }
  },

  // Normal TextField input
  '& .MuiInputBase-input': {
    boxSizing: 'border-box',
    height: 42,
    padding: '0 16px',
    fontFamily: 'Roboto',
    fontSize: 13,
    fontWeight: 400,
    color: '#424242'
  },

  // Select value
  '& .MuiSelect-select': {
    boxSizing: 'border-box',
    height: '42px !important',
    minHeight: '42px !important',
    padding: '0 14px 0 16px !important',
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Roboto',
    fontSize: 13,
    fontWeight: 400,
    color: '#424242'
  },

  // MUI X DatePicker input wrapper
  '& .MuiPickersInputBase-root': {
    height: 42,
    fontFamily: 'Roboto',
    fontSize: 13,
    color: '#424242'
  },

  // DatePicker editable sections
  '& .MuiPickersSectionList-root': {
    height: 42,
    padding: '0 0 0 0',
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Roboto',
    fontSize: 13,
    fontWeight: 400,
    color: '#424242'
  },

  '& .MuiPickersSectionList-section': {
    fontFamily: 'Roboto',
    fontSize: 13,
    fontWeight: 400,
    color: '#424242'
  },

  // DatePicker placeholder: MM/DD/YYYY
  '& .MuiPickersInputBase-root .MuiPickersSectionList-sectionContent': {
    fontFamily: 'Roboto',
    fontSize: 13,
    fontWeight: 400,
    color: '#424242'
  },

  '& .MuiPickersInputBase-root .MuiPickersSectionList-sectionContent.MuiPickersInputBase-sectionContent': {
    fontFamily: 'Roboto',
    fontSize: 13,
    fontWeight: 400,
    color: '#424242'
  },

  // Picker icon area
  '& .MuiInputAdornment-root': {
    marginLeft: 0
  },

  '& .MuiIconButton-root': {
    width: 38,
    height: 38,
    padding: 0,
    color: '#757575'
  },

  '& .MuiSvgIcon-root': {
    fontSize: 20
  },

  // Common label
  '& .MuiInputLabel-root': {
    fontFamily: 'Roboto',
    fontSize: 13,
    fontWeight: 400,
    color: '#757575',
    transform: 'translate(14px, 11px) scale(1)'
  },

  '& .MuiInputLabel-root.MuiInputLabel-shrink': {
    transform: 'translate(14px, -8px) scale(0.75)'
  },

  '& .MuiInputLabel-root.Mui-focused': {
    color: '#1976D2'
  },

  '& .MuiInputLabel-asterisk': {
    color: '#F44336'
  },

  '& .MuiSelect-icon': {
    right: 12,
    color: '#757575'
  }
};
export const dialogHeaderStyles = {
  dialogheader: {
    px: 2,
    py: 1.5,
    borderBottom: '1px solid #E0E0E0',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    backgroundColor: '#F8FAFD'
  },
  title: {
    fontSize: 16,
    fontWeight: 500,
    color: '#424242',
    lineHeight: 1.4
  },
  subtitle: {
    fontSize: 12,
    color: '#424242',
    lineHeight: 1.5
  },
  dialogheaderclose: {
    width: 26,
    height: 26,
    p: 1,

    '&:hover': {
      bgcolor: 'transparent'
    },

    '&.Mui-focusVisible': {
      bgcolor: 'transparent'
    }
  }
};

export const dialogActionSx = {
  px: 2,
  py: 2,
  borderTop: '1px solid #E0E0E0'
};

export const dialogButtonSx = {
  cancel: {
    px: 2,
    fontSize: 13,
    color: '#616161',
    textTransform: 'uppercase',
    fontWeight:400,
    fontFamily:'Roboto',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
  },

  primary: {
    px: 3,
    borderRadius: '4px',
    fontSize: 13,
    textTransform: 'uppercase',
    fontWeight:400,
    fontFamily:'Roboto',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },

    '&.Mui-disabled': {
      backgroundColor: '#EEEEEE',
      color: '#BDBDBD'
    }
  }
};

export const searchFieldSx = {
  '& .MuiOutlinedInput-root': {
    height: 42,
    borderRadius: '4px',
    backgroundColor: '#FFFFFF',

    '& fieldset': {
      borderColor: '#D9D9D9'
    },

    '&:hover fieldset': {
      borderColor: '#C4C4C4'
    },

    '&.Mui-focused fieldset': {
      borderColor: '#1976D2'
    }
  },

  '& .MuiInputBase-input': {
    fontSize: 13,
    color: '#424242',
    padding: '8px 12px 8px 0',

    '&::placeholder': {
      color: '#757575',
      opacity: 1
    }
  },

  '& .MuiInputAdornment-root': {
    marginRight: 0.6,
    marginLeft: 0
  },

  '& .MuiSvgIcon-root': {
    fontSize: 18,
    color: '#757575'
  }
};

export const filterButtonSx = {
  height: 42,
  px: 2,
  borderRadius: '4px',
  borderColor: '#C1DEF2',
  color: '#4E8AC7',
  fontSize: 13,
  fontWeight: 400,
  textTransform: 'none',

  '&:hover': {
    borderColor: '#4E8AC7',
    backgroundColor: '#F5F9FD'
  },

  '& .MuiButton-startIcon': {
    mr: 0.75
  }
};


export const multitextFieldSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '4px',
    backgroundColor: '#FFFFFF',

    '& fieldset': {
      borderColor: '#D9D9D9'
    },

    '&:hover fieldset': {
      borderColor: '#C4C4C4'
    },

    '&.Mui-focused fieldset': {
      borderColor: '#1976D2',
      borderWidth: '1px'
    }
  },

  // Normal TextField input
  '& .MuiInputBase-input': {
    boxSizing: 'border-box',
    padding: '0',
    fontFamily: 'Roboto',
    fontSize: 13,
    fontWeight: 400,
    color: '#424242'
  },

  
  // Common label
  '& .MuiInputLabel-root': {
    fontFamily: 'Roboto',
    fontSize: 13,
    fontWeight: 400,
    color: '#757575',
    transform: 'translate(14px, 11px) scale(1)'
  },

  '& .MuiInputLabel-root.MuiInputLabel-shrink': {
    transform: 'translate(14px, -8px) scale(0.75)'
  },

  '& .MuiInputLabel-root.Mui-focused': {
    color: '#1976D2'
  },

  '& .MuiInputLabel-asterisk': {
    color: '#F44336'
  },

  '& .MuiSelect-icon': {
    right: 12,
    color: '#757575'
  }
};

export const attachButtonSx = {
  mt: 2,
  height: 38,
  px: 2,
  width: 'fit-content', // Prevent full width
//   minWidth: 190,
  borderRadius: '4px',
  borderColor: '#E0E0E0',
  backgroundColor: '#FFFFFF',
  color: '#C39751',
  fontSize: 12,
  fontWeight: 500,
  textTransform: 'uppercase',

  '& .MuiButton-startIcon': {
    mr: 0.5
  },

  '&:hover': {
    backgroundColor: '#FCF8F2',
    borderColor: '#D6B27D'
  }
};

export const patientCountChipSx = {
  height: 24,
  borderRadius: '6px',
  backgroundColor: '#F2F2F2',
  color: '#424242',
  fontSize: 12,
  fontWeight: 500
};

export const providerNameSx = {
  fontSize: 16,
  fontWeight: 600,
  color: '#424242'
};

export const patientNameSx = {
  fontSize: 14,
  fontWeight: 500,
  color: '#424242'
};

export const patientMrSx = {
  mt: 0,
  fontSize: 11,
  color: '#424242'
};

export const patientBoxSx = {
  p: 1.5,
  mb: 2,
  bgcolor: '#E6F2F9',
  border: '1px solid #C1DEF2',
  borderRadius: '6px'
};

export const sectionTitleSx = {
  fontSize: 13,
  fontWeight: 500,
  color: '#424242',
  textTransform: 'uppercase'
};

export const issueTextSx = {
  mb: 2,
  fontSize: 13,
  color: '#616161',
  lineHeight: 1.5
};

export const pageHeaderWrapperSx = {
  bgcolor: '#FAFAFA'
};

export const pageHeaderSx = {
  px: 2,
  py: 1.5,
  minHeight: 54,
  display: 'flex',
  alignItems: 'center',
  bgcolor: '#fff',
  borderBottom: '1px solid #E0E0E0'
};

export const pageHeaderTitleSx = {
  fontSize: 18,
  fontWeight: 500
};

export const timelineItemSx = {
  display: 'flex',
  gap: 2
};

export const timelineIconWrapperSx = {
  pt: 0.5
};

export const timelineContentSx = {
  flex: 1
};

export const timelineTitleSx = {
  fontSize: 14,
  fontWeight: 500,
  color: '#212121'
};

export const timelineMetaSx = {
  fontSize: 12,
  color: '#616161',
  mb: 1
};

export const timelineUserSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  fontSize: 13,
  color: '#424242',
  mb: 1
};

export const timelineUserIconSx = {
  fontSize: 17
};

export const timelineMessageSx = {
  p: 2,
  bgcolor: '#FCF8F2',
  borderLeft: '3px solid #F8F1E2',
  borderRadius: 1,
  fontSize: 13,
  color: '#424242',
  fontFamily: 'Roboto'
};

export const settingsTabsWrapperSx = {
  px: 2,
  bgcolor: '#FCF8F2',
  borderBottom: '1px solid #E6E6E6'
};

export const settingsTabsSx = {
  minHeight: 52,
  fontFamily: 'Roboto',

  '& .MuiTabs-indicator': {
    height: 2,
    bgcolor: '#C58A2A'
  },

  '& .MuiTabs-scroller': {
    mx: 1
  },

  '& .MuiTab-root': {
    minHeight: 52,
    minWidth: 'auto',
    px: 0,
    mr:3,
    color: '#424242',
    fontSize: 13,
    fontFamily: 'Roboto',
    textTransform: 'none'
  },

  '& .MuiTab-root.Mui-selected': {
    color: '#C39751',
    fontWeight: 600
  },

  '& .MuiTab-icon': {
    mr: 0.6,
    mb: '0 !important'
  },

  '& .MuiSvgIcon-root': {
    fontSize: 20
  }
};

export const settingsTabIconSx = {
  fontSize: 20
};

export const cardSx = {
  height: '100%',
  backgroundColor: '#FFFFFF',
  boxShadow: 'none',
  overflow: 'hidden'
};

export const cardContentSx = {
  p: 0,

  '&:last-child': {
    pb: 0
  }
};

export const toolbarSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  mb: 1.4
};

export const providerHeaderSx = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 1,
  height:42,
};

export const homeDetailsWrapperSx = {
  width: '100%',
  height: '100%'
};

export const homeDetailsPaperSx = {
  height: '100%',
  p: 1.5,
  overflow: 'hidden',
  backgroundColor: '#fff',
  border: '1px solid #E0E0E0',
  borderRadius: '10px',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.10)'
};

export const homeDetailsColumnSx = {
  height: '100%'
};


export const hideScrollbarSx = {
  overflowY: 'auto',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',

  '&::-webkit-scrollbar': {
    display: 'none'
  }
};


export const footerActionButtonSx = {
  borderRadius: '4px',
  textTransform: 'uppercase',
  fontSize: 12,
  fontWeight: 400,
  boxShadow: 'none',

  '& .MuiButton-startIcon': {
    marginRight: '4px',

    '& svg': {
      fontSize: 18
    }
  },

  '&.Mui-disabled': {
    opacity: 1,
    backgroundColor: '#ECECEC',
    color: '#BDBDBD',
    borderColor: '#E0E0E0'
  }
};

export const deleteButtonSx = {
  ...footerActionButtonSx,
  borderColor: '#E0E0E0',
  color:'#424242',

  '&.Mui-disabled': {
    backgroundColor: '#FFFFFF',
    color: '#BDBDBD',
    borderColor: '#E0E0E0'
  }
};

export const saveButtonSx = {
  ...footerActionButtonSx,
    backgroundColor: '#EFDCB5',
    borderColor: '#E5C686',
  color: '#424242',

  '&:hover': {
    backgroundColor: '#DFC97D',
    boxShadow: 'none'
  }
};

export const eSignButtonSx = {
  ...footerActionButtonSx,
   backgroundColor: '#5697D4',
   '&:hover': {
    boxShadow: 'none'
  }
};

export const panelSx = {
  width: '100%',
  flex: '1 1 auto',
  minWidth: 0,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  bgcolor: '#FFFFFF',
  border: '1px solid #E0E0E0',
  borderRadius: '8px',
  overflow: 'hidden'
};

export const headerCellSx = {
  height: 40,
  px: 2,
  py: 0,
  bgcolor: '#FAFAFA',
  borderBottom: '1px solid #E0E0E0',
  boxSizing: 'border-box',

  '&.MuiTableCell-stickyHeader': {
    bgcolor: '#FAFAFA'
  }
};

export const addRowSx = {
  height: 40,
  bgcolor: '#FFFFFF',
  cursor:'pointer',

  '&:hover': {
    bgcolor: '#FCF8F2 !important'
  },

  '&.Mui-selected': {
        bgcolor: '#FFFFFF !important',

  },

  '&.Mui-selected:hover': {
    bgcolor: '#FCF8F2 !important'
  }
};

export const addInputCellSx = {
  height: 38,
  px: 1.25,
  py: 0.5,
  borderBottom: '1px solid #E0E0E0',
  boxSizing: 'border-box'
};
export const ACTION_COLUMN_WIDTH = 82;

export const addActionCellSx = {
  width: ACTION_COLUMN_WIDTH,
  minWidth: ACTION_COLUMN_WIDTH,
  maxWidth: ACTION_COLUMN_WIDTH,
  height: 44,
  p: 0,
  borderBottom: '1px solid #E0E0E0',
  boxSizing: 'border-box',
  alignItems:'end',

};

export const actionWrapperSx = {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'end',
  gap: 0.25,
  px:'10px'
};

export const inputSx = {
  width: '100%',
  minWidth: 0,

  '& .MuiOutlinedInput-root': {
    width: '100%',
    height: 40,
    borderRadius: '4px',
    bgcolor: '#FFFFFF',
    fontSize: 13,

    '& fieldset': {
      borderColor: '#D9D9D9'
    },

    '&:hover fieldset': {
      borderColor: '#BDBDBD'
    },

    '&.Mui-focused fieldset': {
      borderColor: '#4A90D9',
      borderWidth: 1
    }
  },

  '& .MuiInputBase-input': {
    minWidth: 0,
    px: 1.5,
    py: 0
  },

  '& .MuiInputBase-input::placeholder': {
    color: '#757575',
    opacity: 1
  }
};

export const actionIconSx = {
  width: 30,
  height: 30,
  flexShrink: 0,

  '&:hover': {
    bgcolor: '#FCF8F2'
  }
};

export const emptyCellSx = {
  height: 80,
  textAlign: 'center',
  borderBottom: 0,
  fontSize: 13,
  color: '#757575'
};

export const scrollContainerSx = {
  flex: '1 1 auto',
  minHeight: 0,
  width: '100%',
  overflowY: 'auto',
  overflowX: 'hidden',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',

  '&::-webkit-scrollbar': {
    display: 'none'
  }
};


export const templatesTableSx = {
  width: '100%',
  tableLayout: 'fixed'
};

export const headerTitleSx = {
  fontSize: 14,
  fontWeight: 500,
  color: '#424242'
};

export const topicTextSx = {
  display: 'block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const actionSvgSx = {
  fontSize: 21
};

export const editSvgSx = {
  fontSize: 19
};

export const addIconSx = {
  color: '#2EAE43',
  transition: 'none',

  '&.Mui-disabled': {
    color: '#A5D6A7'
  }
};

export const saveIconSx = {
  flexShrink: 0,
  color: '#757575',

  '&:hover': {
    bgcolor: '#FCF8F2'
  },

  '&.Mui-disabled': {
    color: '#90CAF9'
  }
};

export const clearIconSx = {
  color: '#F44336',
  fontSize:18,

  '&.Mui-disabled': {
    color: '#FFCDD2'
  }
};

export const editIconButtonSx = {
  color: '#757575',

  '&:hover': {
    bgcolor: '#F5F5F5',
    color: '#1976D2'
  }
};


export const clickableTableRowSx = {
  minHeight: 44,
  cursor: 'pointer',
  transition: 'background-color .2s ease',

  '& .MuiTableCell-root': {
    height: 44,
    py: 0.5,
    borderBottom: '1px solid #E0E0E0'
  },

  // Hover (only when not selected)
  '&:hover': {
    bgcolor: '#FCF8F2 !important'
  },

  // Selected
  '&.Mui-selected': {
    bgcolor: '#FFFFFF !important'
  },

  // Selected + hover should remain gray
  '&.Mui-selected:hover': {
    bgcolor: '#FCF8F2 !important'
  }
};

export const editingTableRowSx = {
  cursor: 'default',

  '&:hover': {
    bgcolor: '#FFFFFF'
  }
};

export const clickableTopicTextSx = {
  ...topicTextSx,
  color: '#4E8AC7',
  cursor: 'pointer',
  transition: 'color 0.2s ease',

  '&:hover': {
    color: '#2F6FAE'
  }
};

export const iconButtonNoAnimationSx = {
  bgcolor: 'transparent',
  transition: 'none',

  '&:hover': {
    bgcolor: 'transparent'
  },

  '&:active': {
    bgcolor: 'transparent',
    transform: 'none'
  },

  '&.Mui-focusVisible': {
    bgcolor: 'transparent'
  },

  '& .MuiTouchRipple-root': {
    display: 'none'
  },

  '& svg': {
    transition: 'none',
    animation: 'none',
    transform: 'none'
  }
};

export const detailsCardSx = {
  ...cardSx,
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  height: '100%',
  minHeight: 0,
  overflow: 'hidden'
};

export const detailsCardContentSx = {
  ...cardContentSx,
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  minHeight: 0,
  overflow: 'hidden'
};